import {SUPPORT_IMAGE_EXTENSIONS, SUPPORT_PO_EXTENSIONS} from 'config/constants';

export const APP_CONFIG = {
    IMAGE: {
        "LOGO": "images/logo.svg",
        "LOGO_MOBILE": "images/logo_mobile.svg",
        "DEFAULT_USER": "images/default_user.svg",
    },

    // 통신
    COMMUNICATION: {
        METHOD: "",
        POLLING: {
            INTERVAL: 1000,
        },
        SSE: {
            DOMAIN: ""
        }
    },
    COMMUNICATION_DATE_FORMAT: "YYYYMMDD",
    COMMUNICATION_TIME_FORMAT: null,   // null is "millisecond" or "unix"

    // 메뉴
    MAIN_MENU: {
        HOME: {
            LIST: [
                "DASHBOARD",
                "MEMBER",
            ]
        },
        RESOURCE: {
            LIST: [
                "DOCUMENT",
                "WATERMARK",
                "VIEW_CONFIG",
            ]
        },
        VIEWER: {
            LIST: [
                "VIEWER",
            ]
        },
        SYSTEM: {
            LIST: [
                "SYSTEM_LOG",
            ]
        }
    },

    // 기능 - 아이디 타입
    ACCOUNT: {
        ID_TYPE: "",            // id or email
        PASSWORD_REQUIRE: {
            ENABLE: true,
            IS_ALPHABET: true,                        // /[a-zA-Z]/.test(password)
            IS_NUMBER: true,                          // /\d/.test(password)
            IS_SPECIAL_CHARACTERS: true,              // /[$@!%*#?&]/.test(password)
            IS_NEED_LENGTH: 10                        // password.length >= IS_NEED_LENGTH (0이면 비활성화)
        },
    },

    // 기능 - 업로드 사이즈
    MAX_UPLOAD_SIZE: 30,
    SUPPORT_FORMAT_LIST: ["PDF"],
    IS_UPLOAD_ZIP: false,
    IS_UPLOAD_MULTI: false,
    IS_UPLOAD_MULTI_DMV: false,
    IS_VIEW_LIMIT: false,
    IS_VIEW_LIMIT_HIT_COUNT: false,
    IS_VIEW_LIMIT_PRINT_COUNT: false,
    IS_VIEW_LIMIT_DOWNLOAD_COUNT: false,
    VIEW_LIMIT_HIT_COUNT: false,
    VIEW_LIMIT_PRINT_COUNT: false,
    VIEW_LIMIT_DOWNLOAD_COUNT: false,

    // ui
    WATERMARK_TEXT_FONT_LIST: [
        {name: "NotoSans", value: "NotoSans"},
    ],
    WATERMARK_TEXT_FONT_SIZE_LIST: [
        {name: "8px", value: 8},
        {name: "10px", value: 10},
        {name: "12px", value: 12},
        {name: "14px", value: 14},
        {name: "16px", value: 16},
        {name: "18px", value: 18},
        {name: "20px", value: 20},
        {name: "24px", value: 24},
        {name: "28px", value: 28},
        {name: "32px", value: 32},
        {name: "36px", value: 36},
        {name: "48px", value: 48},
        {name: "64px", value: 64},
        {name: "72px", value: 72},
        {name: "96px", value: 96},
    ],
    WATERMARK_TEXT_FONT_SIZE_COLOR: [
        "#FF763E",
        "#FFB638",
        "#38EB88",
        "#5896F3",
        "#959BA6",
        "#191919",

        "#DA3539",
        "#EA6D8C",
        "#61D8BB",
        "#36C0E0",
        "#484EEA",
        "#C591ED",
    ],
    WATERMARK_IMAGE_FORMAT_LIST: ["png"],
    WATERMARK_IMAGE_UPLOAD_SIZE: 10,

    SUPPORT_PO_EXTENSIONS,
    SUPPORT_IMAGE_EXTENSIONS,
};
